export default class Area {
    id: number;
    code: string;
    name: string;
    location: string;
    number: number;
    notes: string;

    get display() {
        return this.name;
    }

    constructor(data: Partial<Area>) {
        Object.assign(this, data);
    }
}
